<script setup>
import { ref, onMounted, onUnmounted} from 'vue'


import WidgetRoom from './WidgetRoom.vue';
import WidgetMain from './WidgetMain.vue';
import WidgetInfo from './WidgetInfo.vue';

import { useI18n } from 'vue-i18n'
const { t } = useI18n()

import { ChatsStore } from "store/chats";
import NotificationPermissionButton from "../../js/components/NotificationPermissionButton.vue";
const chatsStore = ChatsStore();

const isMobile = ref(false)
const updateViewport = () => {
  isMobile.value = window.innerWidth < 768
}

onMounted(async () => {
  chatsStore.connectSocket()
  chatsStore.checkNotificationUrl()
  chatsStore.checkAndSaveDeviceToken()
  updateViewport()
  window.addEventListener('resize', updateViewport)
})

onUnmounted(() =>{
  chatsStore.disconnectSocket();
  window.removeEventListener('resize', updateViewport)
})

</script>
<template>
  <div class="flex flex-row mx-auto w-full min-h-dvh">

    <div class="w-full md:w-80 bg-[#E7ECF0] relative" v-show="!isMobile || !(chatsStore.room?.id > 0)">
      <WidgetRoom/>
    </div>

    <div class="bg-yellow-70 border-l border-r border-[#686F84] relative flex-1" v-show="!isMobile ? true : chatsStore.room?.id > 0 && !chatsStore.showInfo">
        <WidgetMain :room_id="chatsStore.room.id" v-if="chatsStore.room.id > 0"  :key="chatsStore.keyView"/>
    </div>

    <div class="w-full md:w-80 xsbg-chat-info" v-show="!isMobile ? chatsStore.showInfo : chatsStore.showInfo">
        <WidgetInfo :room_id="chatsStore.room.id" v-if="chatsStore.room.id > 0"  :key="chatsStore.keyView"/>
    </div>
    <NotificationPermissionButton />
  </div>

</template>
